import { types as coreTypes } from '@sitebuilder/core';

const schema: coreTypes.Schema = {
    enableDownload: {
        type: 'boolean',
        title: 'Enable Download',
        description: '',
    },
};

const dependencies: coreTypes.Schema = {
    enableDownload: {
        oneOf: [
            {
                properties: {
                    enableDownload: { enum: [true] },
                    downloadFileType: {
                        type: 'string',
                        title: 'Download File Type',
                        enum: ['.csv', '.xlsx'],
                        default: '.csv',
                    },
                    downloadButtonText: {
                        type: 'string',
                        title: 'Download button text',
                    },
                    downloadFileName: {
                        type: 'string',
                        title: 'Download file name',
                    },
                    downloadFileTabName: {
                        type: 'string',
                        title: 'Download file tab name',
                    },
                    fileNameBasedOnTab: {
                        type: 'boolean',
                        title: 'File name based on tab',
                        enum: [true, false],
                        default: false,
                    },
                    showDownloadAtBottom: {
                        type: 'boolean',
                        title: 'Show Download Button At Bottom',
                        default: false,
                        description: '',
                    },
                },
                dependencies: {
                    fileNameBasedOnTab: {
                        oneOf: [
                            {
                                properties: {
                                    fileNameBasedOnTab: { enum: [true] },
                                    tabDescription: {
                                        type: 'string',
                                        title: 'Description',
                                    },
                                    tabPreDescription: {
                                        type: 'string',
                                        title: 'Pre Description',
                                    },
                                },
                            },
                            {
                                properties: {
                                    fileNameBasedOnTab: { enum: [false] },
                                },
                            },
                        ],
                    },
                },
            },
            {
                properties: {
                    enableDownload: { enum: [false] },
                },
            },
        ],
    },
};

const uiSchema = {
    enableDownload: { 'ui:widget': 'CustomCheckbox' },
    downloadFileType: { 'ui:widget': 'CustomSelect' },
    downloadFileName: { 'ui:widget': 'ResourcePicker' },
    downloadButtonText: { 'ui:widget': 'ResourcePicker' },
    downloadFileTabName: { 'ui:widget': 'ResourcePicker' },
    fileNameBasedOnTab: { 'ui:widget': 'CustomCheckbox' },
    tabDescription: { 'ui:widget': 'ResourcePicker' },
    tabPreDescription: { 'ui:widget': 'ResourcePicker' },
    showDownloadAtBottom: { 'ui:widget': 'CustomCheckbox' },
};

const downloadSchema = {
    schema,
    uiSchema,
    dependencies,
};

export default downloadSchema;
